import { motion } from 'framer-motion'
import React from 'react'
import { cn } from '#app/utils/misc'

interface CircleCheckboxProps {
	checked: boolean
	onChange: () => void
	className?: string
}

const CircleCheckbox = React.forwardRef<HTMLInputElement, CircleCheckboxProps>(
	({ checked, onChange, className }, ref) => (
		<motion.div
			className={cn(
				'relative flex h-6 w-6 items-center justify-center rounded-full border transition-colors duration-300 ease-in-out',
				checked
					? 'border-blue-600 bg-blue-600'
					: 'border-gray-300 bg-white dark:border-gray-600 dark:bg-gray-800',
				className,
			)}
			whileTap={{ scale: 0.9 }}
			onClick={onChange}
		>
			<motion.div
				className="absolute inset-0 flex items-center justify-center"
				initial={false}
				animate={{
					scale: checked ? 1 : 0,
					opacity: checked ? 1 : 0,
				}}
				transition={{ duration: 0.2 }}
			>
				<div className="h-2.5 w-2.5 rounded-full bg-white" />
			</motion.div>
			<input
				type="checkbox"
				className="absolute opacity-0"
				ref={ref}
				checked={checked}
				onChange={onChange}
			/>
		</motion.div>
	),
)

CircleCheckbox.displayName = 'CircleCheckbox'

export { CircleCheckbox }
